<template>
  <div class="border-style border-main-color rounded shadow-sm " style="">

    <div class="">

      <div class="row m-0 bg-custom-bg-color py-2 px-3 align-items-center">
        <div class="row m-0 p-0 col-lg-10 col-sm-7 col-12 align-items-center">
          <TagItem :text="'訂單編號'" :color="'white'"/>
          <span class="ml-2"/>
          <span class="text-custom-text font-weight-500">{{ order_id }}</span>
          <button class="btn no-hover btn-icon-only" @click="clickCopy(order_id)">
            <i class="fa fa-clone"></i>
          </button>
        </div>

        <div class="col-lg-2 col-sm-5 col-12 p-0">
          <div class="row m-0 align-items-center justify-content-sm-end ">
            <TagItem :text="order_type"></TagItem>
            <span class="p-1"></span>
            <i class="fa fa-angle-right text-main-color"></i>
          </div>
        </div>
      </div>

      <div class="row m-0 py-2 px-3 justify-content-between">
        <div>
          <span class="text-custom-text font-weight-500">訂單成立日期</span>
          <span class="text-main-color font-weight-500">{{ create_time }}</span>
        </div>
        <div>
          <span class="text-custom-text font-weight-500">最後編輯日期</span>
          <span class="text-main-color font-weight-500">{{ update_time }}</span>
        </div>
      </div>
      <div class="mx-3 display-4 text-custom-text">{{ title }}</div>
      <hr class="mt-3 mb-0">

      <div class="row m-0 py-2 px-3 justify-content-between">
        <div>
          <div class="display-4 text-custom-text font-size-16">訂單預估總金額</div>
          <div class="display-4 text-custom-description font-size-14 ">(正確金額以到貨日匯率計算)</div>
        </div>

        <div>
          <span class="display-4 text-custom-text font-size-30">{{ formPrice(price_data)  }}</span>
          <span class="ml-1"/>
          <span class="display-4 text-custom-text font-size-14 ">元</span>
        </div>
      </div>
      <hr class="m-0">
      <Accordion
          :item_list="item_list"
      />
    </div>
  </div>
</template>

<script>
import Accordion from "@/components/Accordion";
import TagItem from "@/views/components/elements/TagItem";
import {clickCopy,formPrice} from "@/util/helpers";

export default {
  name: "OrderItem",
  components: {
    TagItem: TagItem,
    Accordion: Accordion,
  },
  props: {
    order_id: {
      type: String,
      default: '',
    },
    order_type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: ""
    },
    create_time: {
      type: String,
      default: ""
    },
    update_time: {
      type: String,
      default: ""
    },
    price_data: {
      type: Object,
      default: () => {},
    },
    item_list: {
      type: Array,
      default: () => [],
    }
  },
  methods: {
    clickAction() {
      console.log('news_item click');
    },
    clickCopy(str) {
      clickCopy(str)
    },
    formPrice(price_data){
      return formPrice(price_data);
    }
  }
}
</script>

<style scoped>

.border-style {
  border: solid;
  border-width: 0 0 0 5px;
}


</style>
